import request from '@/utils/authRequest'

export function login(data) {
  return request({
    url: '/auth/login',
    method: 'post',
    data
  })
}

export function register(data) {
  return request({
    url: '/auth/register',
    method: 'post',
    data
  })
}

export function resetPassword(data) {
  return request({
    url: '/users/password',
    method: 'put',
    data
  })
}

export function resetPasswordByEmail(data) {
  return request({
    url: '/auth/reset-password-by-email',
    method: 'post',
    data
  })
}

export function getInfo() {
  return request({
    url: '/permissions/current',
    method: 'get'
  })
}

export function logout() {
  return request({
    url: '/auth/logout',
    method: 'post'
  })
}

export function getCaptcha(data) {
  return request({
    url: '/auth/send-email-code',
    method: 'post',
    data
  })
}

export function getUserList(params) {
  return request({
    url: '/users',
    method: 'get',
    params
  })
}

export function saveUser(data) {
  return request({
    url: '/users',
    method: 'post',
    data
  })
}

export function saveAccount(data) {
  return request({
    url: '/users/sub-account',
    method: 'post',
    data
  })
}

export function getUserById(params) {
  return request({
    url: `/users/${params.userId}`,
    method: 'get',
    params
  })
}

export function updateUser(data) {
  return request({
    url: `/users/${data.userId}`,
    method: 'put',
    data
  })
}
